<div class="dialog-container">
    <div class="dialog-content">
        <h4>{{message}}</h4>
    </div>
    <div class="dialog-actions">
        <button class="custom-button custom-button-flat" (click)="close()">OK</button>
    </div>
</div>
